module.exports = __webpack_public_path__ + "img/Distribution_1.png";